import { useQuery } from '@tanstack/react-query';
import { getIs24SolvencyStatus, getSchufaStatus } from '../api/solvencyInfo/solvencyInfo';

export const useGetSchufaStatus = () => {
  const { isLoading, isFetching, data, isError } = useQuery({
    queryKey: ['schufa-status'],
    queryFn: getSchufaStatus,
  });

  return {
    initializing: isLoading || isFetching,
    schufaStatus: data,
    isSchufaStatusError: isError,
  };
};

export const useGetIs24SolvencyStatus = () => {
  const { isLoading, isFetching, data, isError } = useQuery({
    queryKey: ['is24solvency-status'],
    queryFn: getIs24SolvencyStatus,
  });

  return {
    initializing: isLoading || isFetching,
    is24SolvencyStatus: data,
    isIs24SolvencyStatusError: isError,
  };
};
